import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  ref: "video",
  class: "absolute top-0 left-1/2 rounded-md h-60 m-0 max-w-fit pointer-events-none -translate-x-2/4",
  loop: "",
  autoplay: "",
  muted: ""
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "flex text-md py-1 max-w-60 w-60 block w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Cog6ToothIcon = _resolveComponent("Cog6ToothIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "group relative block hover:opacity-90 w-60 mx-auto lg:mx-0 pb-10 lg:pb-0",
    onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMouseenter && _ctx.onMouseenter(...args))),
    onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMouseleave && _ctx.onMouseleave(...args))),
    title: _ctx.sceneName
  }, [
    _createVNode(_component_router_link, {
      to: _ctx.editSceneRoute,
      class: "block relative rounded-md overflow-hidden bg-gray-200 h-60 w-60 min-w-60 bg-cover bg-center",
      style: _normalizeStyle(_ctx.thumbnailStyleObject)
    }, {
      default: _withCtx(() => [
        (_ctx.videoExists && _ctx.videoDisplayed)
          ? (_openBlock(), _createElementBlock("video", _hoisted_2, [
              _createElementVNode("source", {
                src: _ctx.videoUrl,
                type: "video/mp4"
              }, null, 8 /* PROPS */, _hoisted_3)
            ], 512 /* NEED_PATCH */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["to", "style"]),
    (_ctx.displayBottomBar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: _ctx.editSceneRoute,
            class: "flex-grow truncate text-emerald-400 group-hover:text-emerald-200"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.sceneName), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"]),
          _createVNode(_component_router_link, {
            to: _ctx.settingsSceneRoute,
            class: "text-emerald-400 hover:text-emerald-200"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Cog6ToothIcon, {
                class: "h-5",
                title: "scene settings"
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"])
        ]))
      : _createCommentVNode("v-if", true)
  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1))
}